import { render, staticRenderFns } from "./TablePartnerItem.vue?vue&type=template&id=892c0046&scoped=true"
import script from "./TablePartnerItem.vue?vue&type=script&lang=js"
export * from "./TablePartnerItem.vue?vue&type=script&lang=js"
import style0 from "./TablePartnerItem.vue?vue&type=style&index=0&id=892c0046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c0046",
  null
  
)

export default component.exports